export function init($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    $($name).change(function () {
        if(this.checked) {
            $('.alternative-group').show()
        }else{
            $('.alternative-group').hide()
        }
    })
}